export default [
  {
    path: '/sessions-training',
    name: 'sessions-training',
    component: () => import('@/views/sessions-training/SessionsTraining.vue'),
  },
  {
    path: '/sessions-training/add',
    name: 'add-sessions-training',
    component: () => import(
      '@/views/sessions-training/control-sessions-training/AddEditSessionsTraining.vue'
    ),
    meta: {
      title: 'Add Sessions Training',
      requiresAuth: true,
      action: 'create',
      resource: 'Add Sessions Training',
      pageTitle: 'Add Sessions Training',
      breadcrumb: [
        {
          text: 'Sessions Training List',
          to: '/sessions-training',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sessions-training/:id',
    name: 'edit-sessions-training',
    component: () => import(
      '@/views/sessions-training/control-sessions-training/AddEditSessionsTraining.vue'
    ),
    meta: {
      title: 'Edit Sessions Training ',
      requiresAuth: true,
      pageTitle: 'Sessions Training',
      breadcrumb: [
        {
          text: 'Sessions Training list',
          to: '/sessions-training',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
